import React from 'react';
import PropTypes from 'prop-types';
import { Typography, withStyles } from 'material-ui';
import Dictionary from '../../model/Dictionary';

const styles = { root: { fontSize: '13.5px' } };

const SeatRowAction = ({ passenger, classes }) => (
  <Typography type='title' color='secondary' variant='button' className={classes.root}>
    {passenger && passenger.seatId && passenger.seatPreview ?
      `${Dictionary.seat.seat} ${passenger.seatPreview}` :
      Dictionary.seat.select}
  </Typography>
);

SeatRowAction.propTypes = {
  classes: PropTypes.object,
  passenger: PropTypes.object,
};

export default withStyles(styles)(SeatRowAction);



// WEBPACK FOOTER //
// ./src/containers/passengersList/SeatRowAction.js